import Layout from "../components/layout/Layout";
import PointConfiguration from "../components/page/PointConfiguration";
import {PointServiceGuard} from "../components/ServiceGuard";

const PointConfigurationPage = () => {
  return (
    <Layout>
      {/* 가드는 Layout **안쪽**이다 — `PointUsers.js` 와 같은 이유. */}
      <PointServiceGuard>
        <PointConfiguration />
      </PointServiceGuard>
    </Layout>
  );
};
export default PointConfigurationPage;
